import { Icon } from '@components';

import theme from '../../../../themes/colors';

interface PlanExpiredToastContentProps {
  message: string | null;
  className?: string;
}

const PlanExpiredToastContent = ({
  message,
  className = ''
}: PlanExpiredToastContentProps) => (
  <div
    className={`flex w-full justify-start gap-2 rounded-xl bg-cofeeYellow1 p-4 pb-6 ${className}`}
  >
    <Icon
      name="alert-circle"
      stroke={theme.cofeeYellow8}
      className="mt-1 !size-5 text-cofeeYellow6"
    />
    <div className="flex cursor-default flex-col gap-1">
      <div className="text-lg font-semibold text-cofeeNeutral10">
        Renew Plan
      </div>
      <div className="text-base text-cofeeNeutral8">{message}</div>
    </div>
  </div>
);

export default PlanExpiredToastContent;
